import * as React from 'react';

import styled from 'styled-components';
import Flex from '@components/layout/flex';

import DropdownCtrl from '@webapp/controllers/form/dropdown';
import { Translate } from 'react-localize-redux';
import CircleCheckFilled from '@components/basics/icons/circle-check-filled';

interface DarkLightCtrlProps {
  className?: string;
  value?: string;
  onChange: (time: any) => void;
  isGrey?: boolean;
}

const DarkLightCtrl: React.FC<DarkLightCtrlProps> = (props) => {
  const handleChange = (value: string) => {
    props.onChange(value);
  };
  const DARKLIGHT = [
    {
      label: 'Dark',
      value: 'dark',
      rightDecoration:
        props.value === 'dark' ? (
          <CircleCheckFilled iconSize={18} noAnimation />
        ) : undefined,
    },
    {
      label: 'Light',
      value: 'light',
      rightDecoration:
        props.value === 'light' ? (
          <CircleCheckFilled iconSize={18} noAnimation />
        ) : undefined,
    },
  ];
  const renderImage = () => {
    return (
      <>
        <DotDark />
        <DotRed />
      </>
    );
  };
  return (
    <ReleaseTimeWrapper className={props.className}>
      <DropdownCtrl
        isGrey={props.isGrey ?? false}
        className="w-100"
        title={<Translate id="ARTIST_SETTINGS.TRACPAGE.THEME.LABEL" />}
        value={props.value}
        options={DARKLIGHT}
        onChange={handleChange}
        renderImage={renderImage}
      />
    </ReleaseTimeWrapper>
  );
};

export default DarkLightCtrl;

const ReleaseTimeWrapper = styled(Flex)`
  width: 100%;
  .w-100 {
    width: 100%;
  }
`;

const DotDark = styled.div`
  height: 15px;
  width: 15px;
  background-color: #32343c;
  border-radius: 50%;
  display: inline-block;
  border: 2px solid #fff;
`;
const DotRed = styled.div`
  height: 15px;
  width: 15px;
  background-color: #ed3438;
  border-radius: 50%;
  display: inline-block;
  margin-left: -7px;
  margin-right: 5px;
  border: 2px solid #fff;
`;
